<template>
  <div class="video-groups">
    <div v-for="video_group in video_groups" class="video-group-box" v-bind:key="video_group.id">
      <video-thumb-progress
        :to="{name: 'video', params: {id: video_group.first_video_id}}"
        :thumb="video_group.thumb"
        value="20"
      />
      <div class="video-box-texts">
        <h3>{{video_group.name}}</h3>
        <!-- <div class="text-mute">{{video_group.description}}</div> -->
      </div>
      <router-link
        v-if="video_group.first_video_id"
        :to="{name: 'video', params: {id: video_group.first_video_id}}"
        class="watch"
      >
        <div class="watch-content">
          <play-button />Pozrieť video
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>

import PlayButton from "./PlayButton";
import VideoThumbProgress from "./VideoThumbProgress"

export default {
  props: ["video_groups"],
  components: {
    "video-thumb-progress": VideoThumbProgress,
    "play-button": PlayButton
  }
};
</script>

<style lang="less" scoped>
.video-groups {
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  -ms-grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));

  display: grid;
  grid-column-gap: 20px;
  -ms-grid-column-gap: 20px;
  grid-row-gap: 20px;
  -ms-grid-row-gap: 20px;
}

.video-group-box {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  flex-direction: column;

  flex: 1;
  padding: 0;
  border: 1px solid #eeeeee;
  background: #ffffff;

  .video-box-texts {
    padding: 18px 20px 15px 28px;
  }

  a,
  a:hover,
  a:visited,
  a:link,
  a:active {
    &.watch {
      border-top: 1px solid #e1e1e1;
      margin: 3px auto;
      padding: 2px;
      width: 100%;
      height: 38px;
      margin-top: auto;

      .watch-content {
        margin: 4px auto;
        width: 8em;
        color: #b11116;
        text-decoration: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/public_app/pages/videozone/VideoGroupsList.vue